import NotFooterLayout from "layouts/NotFooterLayout";
import OrderCard from "components/OrderManage";
import Main from "layouts/Main";
import { useAppDispatch } from "store";
import { setFooterShow } from 'store/slices/layoutSlice';

function OrderPage() {
//  const dispatch = useAppDispatch();

  //show footer
 // dispatch(setFooterShow(true));
  return (
    <>
      <NotFooterLayout namePage="คำสั่งซื้อ">
        <div className="layout-content">
          <OrderCard  />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default OrderPage;
